// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header___2JBR8","page":"style__page___3K1y-","title":"style__title___CL2sv","qrContainer":"style__qrContainer___1mEa6","errorContainer":"style__errorContainer___eUCsP"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/business/ui/screens/scan-sticker/style.css
// module id = 1086
// module chunks = 0